// import axios, { AxiosResponse } from 'axios'
import firebase from 'firebase'
import { $axios } from '@app/utils/api'
export default function () {
  $axios.onRequest(async (config) => {
    // firebaseの認証済みではない場合
    if (!firebase.auth().currentUser) return config

    // firebaseで認証済みの場合はtokenを取得してheaderにセットする
    try {
      const token = await firebase
        .auth()
        .currentUser?.getIdToken()
        .catch((e) => {
          throw new Error('firebase error')
        })
      config.headers.Authorization = `Bearer ${token}`
      return config
    } catch (e) {
      throw e
    }
  })
}
